import React, { useEffect } from 'react';
import { Button, Drawer, Form, Select } from 'antd';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import useDepartmentOptions from '../../hooks/useDepartmentOptions';
import useEmployeeOptions from '../../hooks/useEmployeeOptions';
import TableLoader from '../../components/loaders/TableLoader';
import { DropdownIconNew } from '../../theme/SvgIcons';
import { FieldBox } from '../projects/ProjectStyle';
import { ButtonWrapper } from '../../theme/common_style';

const ReportingFilters = ({ open, onClose, setAppliedFilter, appliedFilter }) => {
  const [form] = Form.useForm();
  const { isEmployee } = useSelector((state) => state?.userInfo);
  const { options: departmentOptions, loading: loadingDepartments } = useDepartmentOptions();
  const { loading: employeeLoading, options: employeeOption } = useEmployeeOptions();

  const onSubmit = (values) => {
    const formattedValues = {
      ...values
    };
    setAppliedFilter(formattedValues);
    onClose();
  };

  const onReset = () => {
    form.resetFields();
    setAppliedFilter(null);
    onClose();
  };

  useEffect(() => {
    if (appliedFilter) {
      form.setFieldsValue({
        ...appliedFilter,
        date: [
          appliedFilter?.date?.[0]
            ? dayjs(appliedFilter.date?.[0]).isValid()
              ? dayjs(appliedFilter.date?.[0])
              : null
            : null,
          appliedFilter?.date?.[1]
            ? dayjs(appliedFilter.date?.[1]).isValid()
              ? dayjs(appliedFilter.date?.[1])
              : null
            : null
        ]
      });
    }
  }, [appliedFilter]);

  return (
    <Drawer
      width={490}
      title="Filters"
      placement="right"
      closable={true}
      prefixCls="activityCustomDrawer"
      onClose={onClose}
      open={open}
      key="right">
      <ContainerStyle>
        {!loadingDepartments && !employeeLoading ? (
          <Form style={{ height: '100%' }} form={form} onFinish={onSubmit}>
            {() => (
              <div className="filter-flex">
                <div>
                  {!isEmployee && (
                    <FieldBox>
                      <label htmlFor="employeeId">Filter by Employee</label>
                      <Form.Item name="employeeId">
                        <Select
                          className="customHeight"
                          allowClear
                          suffixIcon={<DropdownIconNew />}
                          loading={employeeLoading}
                          placeholder="--Select Option--"
                          options={employeeOption}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </FieldBox>
                  )}
                  {!isEmployee && (
                    <FieldBox>
                      <label htmlFor="departmentId">Filter by Department</label>
                      <Form.Item name="departmentId">
                        <Select
                          className="customHeight"
                          allowClear
                          suffixIcon={<DropdownIconNew />}
                          loading={loadingDepartments}
                          placeholder="--Select Option--"
                          options={departmentOptions}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </FieldBox>
                  )}
                </div>

                <div style={{ paddingBottom: '20px' }}>
                  <ButtonWrapper>
                    <button className="reset" onClick={onReset}>
                      Reset
                    </button>
                    <Button prefixCls="antCustomBtn" style={{ width: '100%' }} htmlType="submit">
                      Apply
                    </Button>
                  </ButtonWrapper>
                </div>
              </div>
            )}
          </Form>
        ) : (
          <div
            className="loader"
            style={{
              height: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <TableLoader size="30px" />
          </div>
        )}
      </ContainerStyle>
    </Drawer>
  );
};

export default ReportingFilters;

ReportingFilters.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  setAppliedFilter: PropTypes.func,
  appliedFilter: PropTypes.object
};

const ContainerStyle = styled.div`
  width: 100%;
  padding: 10px 25px;
  height: 100%;

  .filter-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    margin-bottom: 20px;
  }
`;
